/// <amd-module name="Environments/Providers/Kubernetes/Utilities" />
import { IPod, IService, IDeployment, IReplicaSet } from "./Types";

export function convertPodsForComponent(pods: any): IPod[] {
    pods = safeParseJson(pods);
    return (pods && pods.items || []).map((pod: any) => {
        return {
            name: pod.metadata && pod.metadata.name || "",
            namespace: pod.metadata && pod.metadata.namespace || "",
            status: pod.status && pod.status.phase || "",
            image: pod.spec && pod.spec.containers && pod.spec.containers.length > 0 && pod.spec.containers[0].image || "",
            nodeName: pod.spec && pod.spec.nodeName || ""
        } as IPod;
    });
}

export function convertServicesForComponent(services: any): IService[] {
    services = safeParseJson(services);
    return (services && services.items || []).map((service: any) => {
        return {
            name: service.metadata && service.metadata.name || "",
            namespace: service.metadata && service.metadata.namespace || "",
            type: service.spec && service.spec.type || "",
            clusterIP: service.spec && service.spec.clusterIP || "",
            externalIP: service.status && service.status.loadBalancer && service.status.loadBalancer.ingress && service.status.loadBalancer.ingress.length > 0 && service.status.loadBalancer.ingress[0].ip || "",
        } as IService;
    });
}

export function convertDeploymentsForComponent(deployments: any): IDeployment[] {
    deployments = safeParseJson(deployments);
    return (deployments && deployments.items || []).map((deployment: any) => {
        return {
            name: deployment.metadata && deployment.metadata.name || "",
            namespace: deployment.metadata && deployment.metadata.namespace || "",
            replicas: deployment.spec && deployment.spec.replicas || "",
            readyReplicas: deployment.status && deployment.status.readyReplicas || "",
            strategy: deployment.spec && deployment.spec.strategy && deployment.spec.strategy.type || "",
        } as IDeployment;
    });
}

export function convertReplicaSetsForComponent(replicaSets: any): IReplicaSet[] {
    replicaSets = safeParseJson(replicaSets);
    return (replicaSets && replicaSets.items || []).map((replicaSet: any) => {
        return {
            name: replicaSet.metadata && replicaSet.metadata.name || "",
            namespace: replicaSet.metadata && replicaSet.metadata.namespace || "",
            replicas: replicaSet.spec && replicaSet.spec.replicas || "",
            readyReplicas: replicaSet.status && replicaSet.status.readyReplicas || "",
            appName: replicaSet.metadata && replicaSet.metadata.ownerReferences && replicaSet.metadata.ownerReferences.length > 0 && replicaSet.metadata.ownerReferences[0].name || ""
        } as IReplicaSet;
    });
}

export function safeParseJson(input?: string): any {
    let output = {};
    if (input) {
        try {
            output = JSON.parse(input) || {};
        } 
        catch (e) { }
    }

    return output;
}
